import { render, staticRenderFns } from "./relation-index.vue?vue&type=template&id=824ad5b2&scoped=true"
import script from "./relation-index.vue?vue&type=script&lang=js"
export * from "./relation-index.vue?vue&type=script&lang=js"
import style0 from "./relation-index.vue?vue&type=style&index=0&id=824ad5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824ad5b2",
  null
  
)

export default component.exports